import { useEffect } from 'react';

const useExecuteScript = (content) => {
  useEffect(() => {
    if (!content) return;

    let script = null;
    let retryCount = 0;
    const MAX_RETRIES = 50;
    
    const executeScript = () => {
      try {
        if (!document || !document.body) {
          if (retryCount < MAX_RETRIES) {
            console.log('Document body not available, retrying...', retryCount);
            retryCount++;
            setTimeout(executeScript, 100);
            return;
          } else {
            console.error('Maximum retries reached waiting for document.body');
            return;
          }
        }

        // Extract script content from HTML string
        const scriptContent = content.match(/<script>([\s\S]*?)<\/script>/)?.[1];
        
        if (scriptContent && document.body) {
          // Create and execute script with a unique name
          const uniqueScriptId = `script_${Date.now()}`;
          script = document.createElement('script');
          // Wrap the script content to avoid name collisions
          script.id = "script1";
          script.text = `
            (function() {
              if (window.currentInventoryScript) {
                document.body.removeChild(window.currentInventoryScript);
              }
              ${scriptContent}
            })();
          `;
          
          // Store reference to current script
          //window.currentInventoryScript = script;
          
          // Add to document
          setTimeout(() => {
            if (document.body) {
              document.body.appendChild(script);
            }
          }, 0);
        }
      } catch (error) {
        console.error('Error executing script:', error);
      }
    };

    executeScript();
    
    // Cleanup
    return () => {
      if (script && document.body && script.parentNode) {
        try {
           console.log('removing script');
          document.body.removeChild(script);
        } catch (error) {
          console.error('Error removing script:', error);
        }
      }
    };
  }, [content]);
};

export default useExecuteScript;